import React from 'react';
import { CheckLightGreenIcon } from 'client/components/common/icons';

type Props = {
  name: string;
  comment?: string;
  onClick: () => void;
  isCheckVisible: boolean;
};

export const Option: React.FC<Props> = ({ name, onClick, isCheckVisible, comment }) => {
  return (
    <div onClick={onClick} className={' border-b border-gray3 py-4'}>
      <div className={'flex justify-between'}>
        <span className={`font-bold ${comment ? 'text-gray3 text-opacity-60' : 'text-light-gray3'}`}>{name}</span>
        {isCheckVisible && (
          <span>
            <CheckLightGreenIcon width={18} />
          </span>
        )}
      </div>

      {comment && <p className={'text-xs text-green mt-2'}>{comment}</p>}
    </div>
  );
};
